import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// These values are safe to expose in the client bundle —
// Firebase security is enforced by Firestore Rules, not secret keys.
const firebaseConfig = {
  apiKey:            'AIzaSyDJB-bUJPY2CtJE2l9FqM07l39aczdaM4g',
  authDomain:        'com-golf-scores.firebaseapp.com',
  projectId:         'com-golf-scores',
  storageBucket:     'com-golf-scores.firebasestorage.app',
  messagingSenderId: '864523685937',
  appId:             '1:864523685937:web:10ecb78680816e61be8510',
  measurementId:     'G-93J3HDJG69',
};

const app  = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
export default app;
